import {Typography} from "@material-ui/core";
import React from "react";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

const ConfirmContent = (props) => {

    return (
        <>
            <Box marginY={2}>
                <Typography variant={"overline"}>
                    {props.box.header}
                </Typography>

                <Typography variant={"h6"}>
                    {props.box.content}
                </Typography>
            </Box>

            <Typography variant={"body2"}>
                {props.description}
            </Typography>
        </>
    )
}

ConfirmContent.propTypes = {
    description: PropTypes.string.isRequired,
    box: PropTypes.shape({
        header: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired
    }).isRequired
}

export default ConfirmContent
